import DateService from '../../../services/dateService';

const initialState = {
  selectedSearchApp: 0,
  is_mot: false,
  metaData: null,
  uniqueCities: null,
  uniqueCitiesTrain: null,
  onwardPBDate: null,
  returnPBDate: null,
  pbSourceCity: null,
  pbDestinationCity: null,
  getMetaDataPending: false,
  getMetaDataError: null,
  getUniqueCitiesPending: false,
  getUniqueCitiesError: null,
  transferData: {
    selectedService: null,
    selectedOrigin: null,
    selectedDate: DateService.getTodayString(),
    selectedTime: '00:00',
    selectedStartDate: DateService.getTodayString(),
    selectedStartTime: '00:00',
    selectedEndDate: null,
    selectedEndTime: null,
    selectedKupos: 1,
    selectedAdultKupos: 1,
    selectedKidKupos: 0,
    selectedInfantKupos: 0,
  },
  kuposGoData: {
    selectedServiceType: null,
    selectedVehicleType: null,
    selectedOrigin: null,
    selectedDestination: null,
    selectedDate: DateService.getTodayString(),
    selectedTime: '00:00',
    selectedKupos: 1,
    viaPoints: [],
    name: null,
    lastName: null,
    email: null,
    mobile: null,
    selectedServiceTypeReturn: null,
    selectedVehicleTypeReturn: null,
    selectedOriginReturn: null,
    selectedDestinationReturn: null,
    selectedDateReturn: DateService.getTodayString(),
    selectedTimeReturn: '00:00',
    selectedKuposReturn: 1,
    viaPointsReturn: [],
  },
  kuposGoPostTripDetailsPending: false,
  kuposGoPostTripDetailsError: null,
  resetNewPasswordPending: false,
  resetNewPasswordError: null,
  accountConfirmationPending: false,
  accountConfirmationError: null,
  apiCallPending: false,
  apiCallError: null,
  getSiteMapPending: false,
  getSiteMapError: null,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/home/redux/initialState.js